import React from "react";
import "./index.css"
import Logo1 from '../images/logo.png'
import { useLocation } from 'react-router-dom';

const PageNotFound = () =>{
    const location = useLocation();

    return(
        <div className="flex flex-column page-not-found  line-height-3">
            <p><img src={Logo1} alt="procmart" style={{ width: "250px" }} /></p>
            <p className="mt-0 ml-2"><span className="error-number text-xl">404.</span>&nbsp;&nbsp;<span className="text-xl text-color-secondary">That's an error</span></p>
            <p className="mt-0 ml-2 text-xl font-medium">The Requested URL{location.pathname} was not found on this server</p>
        </div>
    )
}

export default PageNotFound